module.exports = __webpack_public_path__ + "static/media/Username.93154ced.png";